// extracted by mini-css-extract-plugin
export var columnList = "_gx-0";